import { useCallback } from 'react'
import { useNotificationService } from 'src/features/notificationService/useNotificationService'
import { extractHttpErrorMessages } from 'src/state/middleware/saga/handleHttpError'
import { useTemplateEditMode } from '../../context/TemplateEditMode/TemplateEditMode'
import { useMutationDeleteTemplateSpecificMultipleChoices } from '../api/useMutationDeleteTemplateSpecificMultipleChoices'

export const useDeleteTemplateSpecificMultipleChoices = () => {
  const { showNotification } = useNotificationService()
  const templateEditMode = useTemplateEditMode()
  const { mutate, isPending } =
    useMutationDeleteTemplateSpecificMultipleChoices(templateEditMode)
  const deleteTemplateSpecificMultipleChoices = useCallback(
    (multipleChoiceId: number, onSuccess: () => void) => {
      mutate(multipleChoiceId, {
        onSuccess,
        onError: (e: unknown) => {
          showNotification('選択肢の削除に失敗しました', {
            notificationType: 'error',
            duration: 5,
            description: extractHttpErrorMessages(e),
          })
        },
      })
    },
    [mutate, showNotification],
  )
  return {
    deleteTemplateSpecificMultipleChoices,
    isPendingDeleteTemplateSpecificMultipleChoices: isPending,
  }
}
